import React from 'react';
export interface IDisplayLabelProps extends React.HTMLAttributes<HTMLElement> {
    text: string,
}

export const DisplayLabel = (props: IDisplayLabelProps) => {
    return (<label {...props} className="display-label">{props.text}</label>)
}
